<template>
  <app-wrapper>
    <slot/>
  </app-wrapper>
</template>

<script setup lang="ts">
import AppWrapper from "@/layout/AppWrapper.vue";
import {useMessage, useNotification} from "naive-ui";
import {useMessageHandler} from "@/helpers/error/useMessageHandler";
import {useI18n} from "vue-i18n";

const errorMessage = useMessage();
const notification = useNotification();
const messageHandler = useMessageHandler();
messageHandler.errorMessage = errorMessage;
messageHandler.notification = notification;
messageHandler.i18n = useI18n();
</script>

<style lang="scss" scoped>
</style>
